import api from './api'

const skuService = {
  // Trigger a SKU DB -> DynamoDB sync. Returns immediately (202); poll getStatus().
  async sync() {
    const response = await api.post('/sku/sync')
    return response.data
  },

  // Live sync progress: { running, phase, pct, detail, startedAt, lastResult, error, metadata }
  async getStatus() {
    const response = await api.get('/sku/sync-status')
    return response.data
  }
}

export default skuService
